import Color from '@/Enums/Color.enum';
import ScreenAccess from '@/Enums/Screens/ScreenAccess.enum';
import type ScreenKey from '@/Enums/Screens/ScreenKey.enum';
import { SCREENS_WITH_READ_ONLY_ACCESS_OPTION } from '@/constants/screens/readOnlyScreens';
import { Box, FormLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';

interface IProps {
  fieldValue: ScreenAccess | false;
  onChange: (...event: any[]) => void;
  screenName: ScreenKey;
  label: string;
}

const ButtonSX = {
  '&.Mui-selected': {
    backgroundColor: Color.Primary,
    color: 'white',
    '&:hover': {
      backgroundColor: Color.Grey,
    },
  },
  '&:hover': {
    backgroundColor: Color.LightGray,
  },
  '&.Mui-disabled': {
    cursor: 'default',
  },
};

const ButtonGroupValues = [
  {
    name: 'Off',
    value: false,
  },
  {
    name: 'Read',
    value: ScreenAccess.Read,
  },
  {
    name: 'Full',
    value: ScreenAccess.Full,
  },
];

const TripleToggle = ({ fieldValue, onChange, screenName, label }: IProps) => {
  const handleChange = (_, newValue: ScreenAccess | false | null) => {
    if (newValue === null) return;
    onChange(newValue);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mr: 1, my: 0.75 }}>
      <ToggleButtonGroup
        value={fieldValue}
        exclusive
        onChange={handleChange}
        size='small'
        sx={{
          background: 'white',
          borderRadius: '8px',
          height: 30,
          gap: '2px',
          '& .MuiToggleButton-root': {
            fontSize: '0.8rem',
            width: 35,
            height: 30,
            border: 'none',
            borderRadius: '8px',
            textTransform: 'none',
          },
        }}
      >
        {ButtonGroupValues.map((buttonValues, index) => (
          <ToggleButton
            value={buttonValues.value}
            key={index}
            sx={ButtonSX}
            disabled={
              buttonValues.value === ScreenAccess.Read && !SCREENS_WITH_READ_ONLY_ACCESS_OPTION.includes(screenName)
            }
          >
            {buttonValues.name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <FormLabel
        sx={{
          margin: 0,
          lineHeight: 1.5,
        }}
      >
        {label}
      </FormLabel>
    </Box>
  );
};

export default TripleToggle;
